export const TEST_IDS = {
  TWO_CLICK_APP_INSTALL_MPAC_FOCUSED_TASK: 'two-click-app-install-mpac-focused-task',
  INSTALLABLE_APP_PRIVACY_INFORMATION: 'installable-app-privacy-information',
  TWO_CLICK_APP_INSTALL_ERROR_BOUNDARY: 'two-click-app-install-error-boundary',
  PLAN_SELECTOR_TOOLTIP: 'plan-selector-tooltip',
  TWO_CLICK_PLAN_SELECTOR_FREE_BOUGHT_SECTION_MESSAGE: 'two-click-plan-selector-free-bought-section-message',
  TWO_CLICK_PLAN_SELECTOR_ADVANCED_BOUGHT_SECTION_MESSAGE: 'two-click-plan-selector-advanced-bought-section-message',
  TWO_CLICK_PLAN_SELECTOR_STANDARD_BOUGHT_SECTION_MESSAGE: 'two-click-plan-selector-standard-bought-section-message',
  TWO_CLICK_PLAN_SELECTOR_TERMINAL_STANDARD_BOUGHT_SECTION_MESSAGE: 'two-click-plan-selector-terminal-standard-bought-section-message',
  TWO_CLICK_MULTI_INSTANCE_PRICING_SECTION_MESSAGE: 'two-click-multi-instance-pricing-section-message',
  TWO_CLICK_PLAN_SELECTOR_HEADING: 'two-click-plan-selector-heading',
  /* Select an edition */
  TWO_CLICK_PLAN_SELECTOR_RADIO: 'two-click-plan-selector-radio-',
  /* standard or advanced */
  TWO_CLICK_PLAN_SELECTOR_SUBTEXT: 'two-click-plan-selector-subtext-',
  /* EDITIONS_SUBTITLE_CUSTOMERS */
  SELECT_QUANTITY_RADIO_GROUP: 'select-quantity-radio-group',
  SELECT_QUANTITY_SELECT_USERS_RADIO_OPTION: 'select-quantity-select-users-radio-option',
  SELECT_QUANTITY_SELECT_ALL_USERS_RADIO_OPTION: 'select-quantity-select-all-users-radio-option',
  SELECT_QUANTITY_USER_COUNT_INPUT: 'select-quantity-user-count-input'
};
export const USER_SELECTION_TEXT = {
  HEADING: 'Select quantity',
  SELECT_USER_LABEL: 'Specific number of users',
  SELECT_USER_DESCRIPTION: 'Pay only for the selected number of users with access. You can always manage access via Atlassian Administration.',
  ALL_USERS_LABEL: 'All users of the Atlassian app',
  ALL_USERS_DESCRIPTION: 'Pay for all users linked to the Atlassian app. You can always manage access via Atlassian Administration.',
  QUANTITY_INPUT_ARIA_LABEL: 'Number of users'
};